import L from 'leaflet';

export interface DivIconOptions extends L.DivIconOptions {
    title?: string;
}

export interface DivIcon {
    options: DivIconOptions;
}

export class DivIcon extends L.DivIcon {
    constructor(options: DivIconOptions) {
        super(options);
    }

    createIcon(oldIcon?: HTMLElement): HTMLElement {
        const icon = super.createIcon(oldIcon);
        if (this.options.title) {
            icon.setAttribute('title', this.options.title);
        }

        return icon;
    }
}
